import { safeWindow } from '@sky-distribution/gp-onboarding-shared-utils';
import { v4 as uuid } from 'uuid';

const SESSION_ID_KEY = 'sessionId';

export const getSessionId = (): string => {
  let sessionId = safeWindow()?.sessionStorage?.getItem(SESSION_ID_KEY);

  if (!sessionId) {
    sessionId = uuid();
    safeWindow()?.sessionStorage?.setItem(SESSION_ID_KEY, sessionId);
  }

  return sessionId;
};
